export enum SSOEnforcementType {
  None = 'none',
  Everyone = 'everyone',
  SelectedDomains = 'selected_domains',
}
